import { getImageFromPage } from '~core';
import { getMetadata } from '~loader/loader-utils';
import slugify from 'slugify';
import { jsPDF } from 'jspdf';
import { getSelectedPagesByUser } from '../../getSelectedPagesByUser';
import { addWatermark } from '~src/utils';
import { getUser } from '~src/user';
import { getGridParameters } from '~core/grigliaProvino';

// Taglierina A4 Orizzontale
// Margine top: 17.5mm (1.75cm)
// Margine left: 15mm (1.5cm)
// Spaziatura orizzontale (tra colonne): 3mm (0.3cm)
// Spaziatura verticale (tra righe): 2mm (0.2cm)
const staticGridParameters = {
  pdf: {
    topMargin: 17.5,
    leftMargin: 15,
  },
  rowInfo: {
    maxItemsToFit: null, // calculated dynamically
    padding: 3, // spaziatura orizzontale tra colonne
  },
  columnInfo: {
    maxItemsToFit: null, // calculated dynamically
    padding: 2, // spaziatura verticale tra righe
  },
};

export default async function generateGrid() {
  const metadata = getMetadata();
  const selectedPagesByUser = getSelectedPagesByUser();

  const { user } = await getUser();

  const gridParameters = getGridParameters();

  const pdfGrid = new jsPDF(gridParameters.pdf.orientation, 'mm', [
    gridParameters.pdf.width,
    gridParameters.pdf.height,
  ]);

  // Calculate how many items fit in each direction
  // Only subtract the left/top margin (no bottom/right margin)
  const availableWidth =
    gridParameters.pdf.width - staticGridParameters.pdf.leftMargin;
  const availableHeight =
    gridParameters.pdf.height - staticGridParameters.pdf.topMargin;

  const maxItemsInRow = Math.floor(
    (availableWidth + staticGridParameters.rowInfo.padding) /
      (gridParameters.format.width + staticGridParameters.rowInfo.padding)
  );
  const maxItemsInColumn = Math.floor(
    (availableHeight + staticGridParameters.columnInfo.padding) /
      (gridParameters.format.height + staticGridParameters.columnInfo.padding)
  );

  let pageNumber = 0;

  for (let page of selectedPagesByUser) {
    pageNumber++;
    if (pageNumber > 1) {
      pdfGrid.addPage();
    }

    let image = await getImageFromPage(page);
    if (user.org_pointer.tipo_istanza === 'demo') {
      image = await addWatermark(image);
    }
    let left = staticGridParameters.pdf.leftMargin;
    let top = staticGridParameters.pdf.topMargin;

    for (let j = 0; j < maxItemsInColumn; j++) {
      for (let i = 0; i < maxItemsInRow; i++) {
        pdfGrid.addImage(
          image,
          'JPEG',
          left,
          top,
          gridParameters.format.width,
          gridParameters.format.height
        );
        left +=
          gridParameters.format.width + staticGridParameters.rowInfo.padding;
      }
      left = staticGridParameters.pdf.leftMargin;
      top +=
        gridParameters.format.height + staticGridParameters.columnInfo.padding;
    }
  }

  const fileName = slugify(
    `Provino-${metadata.projectTypeName}${
      metadata.templatesCategoryName ? `-${metadata.templatesCategoryName}` : ''
    }${metadata.servizioName ? `-${metadata.servizioName}` : ''}${
      metadata.formatName ? `-${metadata.formatName}` : ''
    }.pdf`
  );

  return { pdfGrid, fileName };
}
